import Helmet from "react-helmet"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import classNames from "classnames"
import get from "lodash/get"
import portal from "portalConfig"
import Card from "components/shared/Card"
import ErrorToast from "components/shared/ErrorToast"
import Nav from "components/shared/Nav"
import PartialPageLoader from "components/shared/PartialPageLoader"
import { useVerificationRedirectEffect } from "components/Login/hooks"
import { useCheckUserSession, useRsvpPortal } from "./hooks"
import parkingIcon from "./assets/parking-icon.svg"
import codeRedeemIcon from "./assets/code-redeem.svg"
import enterCodeIcon from "./assets/enter-code.svg"
import reserveSpotIcon from "./assets/reserve-spot.svg"
import manageParkingIcon from "./assets/settings-gear.svg"
import forwardArrow from "./assets/forward-arrow.svg"

import styles from "./Home.module.scss"

const Home = () => {
  useCheckUserSession()
  useVerificationRedirectEffect()
  const { loading: portalLoading, data: portalData } = useRsvpPortal()
  const textReserveSpot = get(portalData, "rsvpPortal.reserveParkingSpotText")
  const textReserveNewCode = get(portalData, "rsvpPortal.reserveNewCodeText")
  const textReserveExistingCode = get(
    portalData,
    "rsvpPortal.reserveExistingCodeText"
  )
  const textManageParking = get(portalData, "rsvpPortal.manageParkingText")

  const [t] = useTranslation()
  const { features } = portal.config

  const renderCard = (icon, text, link) => {
    if (!text) return null
    return (
      <div className={styles.cardWrapper}>
        <Link to={link} className="text-decoration-none">
          <Card>
            <div className={styles.cardBody}>
              <div className={styles.cardHeader}>
                <img src={icon} alt="card" />
                <div className={styles.headerText}>{text}</div>
              </div>
              <img
                src={forwardArrow}
                alt="arrow"
                className={styles.arrowIcon}
              />
            </div>
          </Card>
        </Link>
      </div>
    )
  }

  return (
    <>
      <Helmet title="Welcome" />
      <div className={styles.container}>
        <Nav className={styles.homeNav} hideBackButton />
        <div className={styles.headline}>
          <img src={parkingIcon} alt="parking" />
          <div className={styles.text}>{t("home.title")}</div>
        </div>
        {portalLoading ? (
          <PartialPageLoader />
        ) : (
          <div className="container-sm">
            <div className="row justify-content-center">
              <div className="col-md-8 col-xl-6">
                <div className={classNames(styles.cardsContainer)}>
                  {renderCard(
                    reserveSpotIcon,
                    textReserveSpot,
                    "/select-parking"
                  )}
                  {features.accessCodes && (
                    <>
                      {renderCard(enterCodeIcon, textReserveNewCode, "/code")}
                      {renderCard(
                        codeRedeemIcon,
                        textReserveExistingCode,
                        "/parking-codes"
                      )}
                    </>
                  )}
                  {renderCard(
                    manageParkingIcon,
                    textManageParking,
                    "/parking-reservations"
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ErrorToast />
    </>
  )
}

export default Home
